import React from "react";

const LETTERS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

const MultipleChoice = ({ question, answer, onAnswer }) => {
  const isMulti = question.multiSelect === true;
  const maxSelections = Number.isInteger(question.maxSelections)
    ? question.maxSelections
    : null;

  const handleSelect = (optionId) => {
    if (isMulti) {
      const current = Array.isArray(answer) ? answer : [];
      const alreadySelected = current.includes(optionId);
      if (!alreadySelected && maxSelections != null && current.length >= maxSelections) return;
      const next = current.includes(optionId)
        ? current.filter((id) => id !== optionId)
        : [...current, optionId];
      onAnswer(next);
    } else {
      onAnswer(optionId);
    }
  };

  const isSelected = (optionId) => {
    if (isMulti) {
      return Array.isArray(answer) && answer.includes(optionId);
    }
    return answer === optionId;
  };
  const currentSelections = Array.isArray(answer) ? answer.length : 0;
  const reachedLimit = isMulti && maxSelections != null && currentSelections >= maxSelections;

  return (
    <div className="tbb-quiz__field">
      <div className="tbb-quiz__options">
        {question.options.map((opt, idx) => (
          <button
            key={opt.id}
            type="button"
            className={`tbb-quiz__option${isSelected(opt.id) ? " tbb-quiz__option--selected" : ""}${opt.image?.url ? " tbb-quiz__option--with-image" : ""}`}
            onClick={() => handleSelect(opt.id)}
            disabled={reachedLimit && !isSelected(opt.id)}
          >
            <span className="tbb-quiz__option-main">
              <span className="tbb-quiz__option-badge">{LETTERS[idx]}</span>
              <span className="tbb-quiz__option-text">{opt.label}</span>
            </span>
            {opt.image?.url && (
              <span className="tbb-quiz__option-media">
                <img
                  className="tbb-quiz__option-media-img"
                  src={opt.image.url}
                  alt={opt.image.alt || ""}
                  loading="lazy"
                />
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default MultipleChoice;
